import React, { useState, useEffect, useRef } from "react";
import { LuSearch } from "react-icons/lu";

interface SearchInputProps {
  placeholder?: string;
  onSearch: (value: string) => void;
  className?: string;
}

const SearchInput = ({ placeholder = "Search...", onSearch, className }: SearchInputProps) => {
  const [value, setValue] = useState("");
  const onSearchRef = useRef(onSearch);
  const mounted = useRef(false);

  useEffect(() => {
    onSearchRef.current = onSearch;
  });

  useEffect(() => {
    if (!mounted.current) {
      mounted.current = true;
      return;
    }
    const timer = setTimeout(() => {
      onSearchRef.current(value);
    }, 1000);
    return () => clearTimeout(timer);
  }, [value]);

  return (
    <div className={`relative ${className ?? "w-64"}`}>
      <LuSearch className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={15} />
      <input
        type="text"
        value={value}
        onChange={(e) => setValue(e.target.value)}
        placeholder={placeholder}
        className="w-full border border-gray-200 rounded-lg pl-9 pr-4 py-2 text-[13px] outline-none focus:border-[#0979A1]"
      />
    </div>
  );
};

export default SearchInput;
